

import * as yup from "yup";

export const Inputs = [
  {
    name: "name",
    label: { ar: "الاسم بالكامل", en: 'FullName' },
    type: "text",
    inputType: "text",
    limit: 11,
    placeholder: { ar: " ", en: '' },
    col: "12",
  },
  {
    name: "phone",
    label: { ar: "رقم الجوال", en: "Mobile Number" },
    type: "text",
    inputType: "number",
    limit: 11,
    placeholder: { ar: " ", en: " " },
    col: "12",
  },
  {
    name: "email",
    label: { ar: "البريد الالكترونى", en: 'Email' },
    inputType: "text",
    type: "email",
    placeholder: { ar: "", en: '' },
    limit: 11,
    col: "12",
  },
  {
    name: "password",
    label: { ar: "كلمة المرور", en: "Password" },
    type: "password",
    isPassword: true,
    placeholder: { ar: "", en: "" },
    col: "12",
  },
  {
    name: "confirmpassword",
    label: { ar: "تأكيد كلمة المرور ", en: 'Confirm Password' },
    type: "password",
    isPassword: true,
    placeholder: { ar: "", en: '' },
    col: "12",
  }
]

export const config = {
  url: '/signup',
  signUpFlag: true,
  redirect: false,
  Sendbtn: { ar: 'تسجيل', en: "Register" },
  submitLabels: ["name", "phone", "email", "password"]
}
export const Validation = yup.object().shape({
  name: yup.string().required({ ar: "يجب ادخال الاسم *", en: 'Name is required' }),
  phone: yup.string().required({ ar: 'يجب ادخال  رقم الجوال *', en: 'Phone Number us required' }),
  // email:yup.string().required("يجب ادخال البريد الإلكتروني *"),
  email: yup.string().email({ ar: "البريد الإلكتروني غير صحيح *", en: 'Email is incorrect' }),

  password: yup.string().required({ ar: "يجب ادخال كلمة المرور *", en: 'Password is required' }),
  confirmpassword: yup.string().required({ ar: "يجب ادخال كلمة المرور *", en: 'Password is required' })
    .test('passwords-match', { ar: 'كلمتا المرور لا يتطبقان', en: "Two Passowrds don't match" }, function (value) {
      return this.parent.password === value;
    }),

})